import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useIsAuthenticated, useIsHydrated } from "@/features/auth";
import { Skeleton } from "@/shared/ui";

export default function ProtectedRoute() {
  const isAuthenticated = useIsAuthenticated();
  const isHydrated = useIsHydrated();
  const location = useLocation();

  if (!isHydrated) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="space-y-4 w-64">
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-4 w-1/2" />
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
